import { render, staticRenderFns } from "./UsersGenericComp.vue?vue&type=template&id=65df403e"
import script from "./UsersGenericComp.vue?vue&type=script&lang=ts"
export * from "./UsersGenericComp.vue?vue&type=script&lang=ts"
import style0 from "./UsersGenericComp.vue?vue&type=style&index=0&id=65df403e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports